import React from 'react';
import PropTypes from 'prop-types';
import './BodyStyle.css'; // Import the CSS file

const BodyExtraSmallRegular = ({ text, color }) => {
  return (
    <p className="body-extra-small-regular" style={{ color: color }}>
      {text}
    </p>
  );
};

BodyExtraSmallRegular.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default BodyExtraSmallRegular;